import { GoCardlessAccessScopeEnum } from '@up/data'
import { IsNumber, IsString, IsOptional, IsArray, ValidateNested, IsEnum } from 'class-validator'

export class AgreementRequestDto {
  @IsString()
  institution_id: string

  @IsNumber()
  @IsOptional()
  max_historical_days?: number

  @IsNumber()
  @IsOptional()
  access_valid_for_days?: number

  @IsArray()
  @IsOptional()
  @ValidateNested({ each: true })
  @IsEnum(GoCardlessAccessScopeEnum, { each: true })
  access_scope?: GoCardlessAccessScopeEnum[]

}